import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import BannerComponent from "../components/rescate/banner.component";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import FooterLayouts from "../layouts/footer.layout";
import DescriptionComponent from "../components/rescate/description.component";
import AccordionComponent from "../components/rescate/accordion.component";
import { fichasSeguridad } from "../components/conexion/vehicles.conexion";
import OtrosVehiculosComponent from "../components/concesionarios/otros-vehiculos.component";

const DestacadasPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [fichasData, setFichasData]: any = useState([]);

  useEffect(() => {
    fichasSeguridad().then(function (res: any) {
      setFichasData(res?.data?.data);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active=""
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <div className="home-page-mascara"></div>
        <BannerComponent />
        <DescriptionComponent />
        <AccordionComponent fichasData={fichasData} />
        <OtrosVehiculosComponent />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default DestacadasPage;
